module.exports = __webpack_public_path__ + "static/0009-5f95d17e583eb5f47b4511f44729713f.png";